/* eslint-disable react/no-danger */
import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { colors } from '_styles';
import getNextActiveScreen from '../../helpers';

const Container = styled.div`
  width: 80%;
  margin: auto;
  padding: 20px;
`;

const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Btn = styled.button`
  position: relative;
  font-size: 14px !important;
   
  padding: 20px 0;
  background-color: ${colors.RC_ACTION};
  cursor: pointer;
  border: none;
  border-radius: 8px;
  color: #fff;
  width: 160px;
  height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px auto;
`;

const IntroductionPage = ({
  data, url, damaged_cart_data
}) => {
  const { oidx } = useParams();
  const { push } = useHistory();

  const onClick = () => {
    const nextPage = getNextActiveScreen(
      damaged_cart_data.find(({ oidx: index }) => index === Number(oidx)),
      data.page,
      url
    );
    push(nextPage, {
      damaged_cart_data: damaged_cart_data.find(({ oidx: index }) => index === Number(oidx))
    });
  };

  return (
    <Container>
      <div style={{ marginBottom: 40 }}>
        {parse(data?.text)}
      </div>
      <BtnContainer>
        <Btn onClick={onClick}>
          Continue
        </Btn>
      </BtnContainer>
    </Container>
  );
};

export default connect(
  (store) => ({
    damaged_cart_data: store?.help?.helpItems.filter(({ type }) => type === 'DAMAGED_CART')
  })
)(IntroductionPage);
